import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import useMediaQuery from '../../hooks/useMediaQuery';

const LanguageSelector = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <div className="relative">
      <button
        className={`flex items-center gap-2 hover:text-gray-600 ${isDesktop ? 'text-sm' : 'text-xs'}`}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {t('language')}: {language.toUpperCase()}
        <ChevronDown size={isDesktop ? 16 : 14} />
      </button>
      
      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg z-50">
          <button
            className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${isDesktop ? 'text-sm' : 'text-xs'}`}
            onClick={() => {
              setLanguage('en');
              setIsDropdownOpen(false);
            }}
          >
            English
          </button>
          <button
            className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${isDesktop ? 'text-sm' : 'text-xs'}`}
            onClick={() => {
              setLanguage('sw');
              setIsDropdownOpen(false);
            }}
          >
            Kiswahili
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;